import React, { memo } from 'react'
import { withStyles } from '@material-ui/core/styles'

import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator'

import style from './style'

function Progress({ classes, label }) {
  return (
    <div className={classes.load}>
      <div className={classes.wrap}>
        <LoadingIndicator label={label} />
      </div>
    </div>
  )
}

export default memo(withStyles(style)(Progress))



// WEBPACK FOOTER //
// ./src/Components/Progress/index.js